import type { ButtonHTMLAttributes, ReactNode } from 'react';

/**
 * The button inside the primitives.
 *
 * Deliberately internal, and deliberately small. It exists so a confirm dialog,
 * a toast, and the error fallback all render the same 44px target with the same
 * focus ring, not as the app's button component. The app's button, with the
 * scorebook's 64px variants and its own states, is a separate piece of work
 * against a designed screen.
 */

export type ButtonTone = 'primary' | 'ghost' | 'danger' | 'quiet';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly tone?: ButtonTone;
  readonly children?: ReactNode;
}

export function cx(...parts: readonly (string | false | undefined)[]): string {
  return parts
    .filter((part): part is string => typeof part === 'string' && part.length > 0)
    .join(' ');
}

export function Button({
  tone = 'primary',
  className,
  type = 'button',
  children,
  ...rest
}: ButtonProps): ReactNode {
  return (
    <button {...rest} type={type} className={cx('gs-button', `gs-button--${tone}`, className)}>
      {children}
    </button>
  );
}
